import React, { Component } from "react";
import { PageHeader2, Contact, WebinarBody } from "../components";
import axios from "axios";
import {
  API_DETAIL_EVENTS,
  API_DETAIL_EVENTS_BYID,
  API_DETAIL_WEBINARS,
  API_MAIN,
} from "../utils/constants";

export class Detail_webinar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      detail: [],
      detail2: [],
      main: [],
    };
  }

  componentDidMount() {
    this.getMain();
  }

  getData(slug) {
    const headers = {};
    axios
      .get(API_DETAIL_WEBINARS + "?slug=" + slug, { headers: headers })
      .then((res) => {
        const detail = res.data.webinars;
        this.setState({ detail });
        if (this.state.main.LANG) {
          if (detail.LANG !== this.state.main.LANG) {
            if (detail.LANG_REF === 0 || detail.LANG_REF === "0") {
              window.location.href = "/";
            } else {
              axios
                .get(API_DETAIL_EVENTS_BYID + "?id=" + detail.LANG_REF, {
                  headers: headers,
                })
                .then((response) => {
                  const detail2 = response.data.events;
                  this.setState({ detail2 });
                  window.location.href = "/webinar/" + detail2.SLUG;
                });
            }
          }
        }
      })
      .catch((error) => {
        console.log("Error yaa ", error);
      });
  }

  getMain() {
    const headers = {};
    axios
      .get(API_MAIN, { headers: headers })
      .then((res) => {
        const main = res.data.main;
        this.setState({ main });
        this.getData(this.props.match.params.slug);
      })
      .catch((error) => {
        console.log("Error yaa ", error);
      });
  }

  render() {
    const { detail, main } = this.state;
    const param = {
      title: detail.NAME,
      subtitle: "",
      breadcrumb1: detail.NAME,
      breadcrumb: "Webinar",
      breadcrumbLink: "/webinar/page/1",
    };

    return (
      <main>
        <div role="main" className="main">
          <PageHeader2 param={param} />
          <WebinarBody param={detail} />
          <Contact data={main} />
        </div>
      </main>
    );
  }
}

export default Detail_webinar;
